import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const maxCustomerTitleLength = 36;
const formatCustomerTitle = displayName => (
  displayName.length < maxCustomerTitleLength ? displayName : `${displayName.slice(0, maxCustomerTitleLength - 3)}...`
);

export const CustomerTile = ({
  displayName, displayAccountCount, customerNumber, customerUrl, classes,
}) => (
  <a className="customer-tile" href={customerUrl}>
    <div className={classes.customerTileFirstLine}>
      <span className={classnames('name-span', classes.customerTitle)}>{formatCustomerTitle(displayName)}</span>
      <span className={classnames('accountcount-span', classes.accountCount)}>{displayAccountCount}</span>
    </div>
    <div className={classnames('id-span', classes.accountId)}>{customerNumber}</div>
  </a>
);

CustomerTile.propTypes = {
  displayName: PropTypes.string.isRequired,
  displayAccountCount: PropTypes.string.isRequired,
  customerNumber: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  customerUrl: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    customerTileFirstLine: PropTypes.string,
    customerTitle: PropTypes.string,
    accountCount: PropTypes.string,
    accountId: PropTypes.string,
  }).isRequired,
};
